import React, { useState, useEffect, useCallback } from 'react';

import { Input } from 'reactstrap';
import { intStringToCurrencyDisplay, floatStringToIntString } from 'app/employer/redux/form/format';
import { toIntStringCurrency } from 'app/employer/redux/form/normalize';

/*
   PROPS
      allowNegative

   the attribute allowNegative allows the values to be negative
   otherwise always assume the field will accept only positive values
   also convert all the values coming in to this field to be strings
   instead of the numerical values
*/

const ReduxCurrencyInput = ({ input: { onChange, onBlur, value, ...restInput }, meta: { touched, error, warning }, className, allowNegative = false, allowEmptyInput = false, ...custom }) => {
   const [innerValue, setInnerValue] = useState(value);

   // Morphs the redux-store value to be displayed with commas appropriately

   useEffect(() => {
      let newInnerValue = '';
      // const sanitizedValue = value.replace(/[^(\d|.)]/g, '');
      if (value) {
         const isNegative = ('' + value).indexOf('-') > -1;
         const intString = floatStringToIntString(('' + value).replace('-', ''));
         // console.log('intString=', intString)
         newInnerValue = (isNegative ? '-' : '') + intStringToCurrencyDisplay(intString);
      }
      setInnerValue(newInnerValue);
   }, [value]);

   const handleInputChange = useCallback((event) => {
      // Sanitize input to only capture digit input
      let val = toIntStringCurrency(allowNegative ? event.target.value : event.target.value.replace('-', ''), undefined, allowEmptyInput);
      const DEFAULT_VALUE = allowEmptyInput ? '' : '0';
      const finalVal = val ? val.substring(0, val.length - 2) + '.' + val.substring(val.length - 2) : DEFAULT_VALUE;
      if (onChange) {
         onChange(finalVal);
      }
   }, []);

   return (
      <Input {...(touched ? { valid: !error } : {})} {...restInput} onChange={handleInputChange}
         onBlur={handleInputChange} {...custom}
         className={(touched && error ? ' is-invalid ' : '') + (className ? ' ' + className : '')}
         value={innerValue}
      />
   );
};

export default ReduxCurrencyInput;
